export const contextKey = Symbol("Rollbar context key");
